import { render, staticRenderFns } from "./CurrentPlanBanner.vue?vue&type=template&id=afd481e0"
import script from "./CurrentPlanBanner.vue?vue&type=script&lang=js"
export * from "./CurrentPlanBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports